import { Box, Button, Text } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../../../../common/hooks/useBrandedTranslation"

type Props = {
  isBoxShadow: boolean
  isSelectedProductsCountShown: boolean
  selectedProductsCount: number
  resetAllClickFunction: () => void
  isCloseButtonActive: boolean
  isResetAllRendered: boolean
}

const FilterFormFooter = ({
  isBoxShadow,
  isSelectedProductsCountShown,
  selectedProductsCount,
  resetAllClickFunction,
  isCloseButtonActive,
  isResetAllRendered,
}: Props) => {
  const { t } = useBrandedTranslation()

  return (
    <Box
      position="sticky"
      bottom="0"
      px={{ base: "4", sm: "6", md: "2" }}
      py={{ base: "6", md: "2" }}
      width="100%"
      bg="white"
      boxShadow={isBoxShadow && "0 -10px 20px 0 #ffffff"}
    >
      <Button id="filter-footer-submit-button" variant="primary" type="submit" width="100%">
        <Text fontSize="sm" fontWeight="medium">
          {isCloseButtonActive
            ? t("search-filters-close")
            : t("search-filters-view-results", {
                count: isSelectedProductsCountShown ? selectedProductsCount : 0,
                n: isSelectedProductsCountShown ? selectedProductsCount : "",
              })}
        </Text>
      </Button>

      {isResetAllRendered && (
        <Button
          mt={{ base: "6", md: "2" }}
          w="100%"
          color="black"
          border={{ base: "1px solid", md: "none" }}
          variant="secondary"
          aria-label="Reset all filters"
          onClick={resetAllClickFunction}
        >
          {t("search-filters-reset-all")}
        </Button>
      )}
    </Box>
  )
}

export default FilterFormFooter
